import { createDeformedCube } from "./CubeBase";

// 正解の立方体（モチーフ）。faceColors で面着色、errorEdges で辺の強調表示
export function createCube(faceColors, errorEdges) {
  return createDeformedCube((x, y, z) => [x, y, z], faceColors, errorEdges);
}
